<template>
  <v-card class="fact-card pa-2" :class="{ selected: fact.selected }" @click="onChange">
    <h5 class="mb-3">{{ fact.title_sve }}</h5>
    <p>{{ fact.text_sve }}</p>
  </v-card>
</template>

<script>
export default {
  name: 'Artfact',
  props: {
    fact: { type: Object },
  },
  computed: {},
  methods: {
    onChange() {
      const fact = { fact_id: this.fact.id, selected: !this.fact.selected }
      this.$emit('change', fact)
    },
  },
}
</script>

<style lang="less" scoped>
.fact-card {
  position: relative;
  cursor: pointer;
  &.selected {
    background-color: rgba(126, 173, 97, 0.3);
    border: rgba(126, 173, 97, 0.9) 1px solid;
  }
  p {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .delete-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 1;
    opacity: 0;
  }
  &:hover .delete-btn {
    opacity: 1;
  }
}
</style>
